// src/components/meta/MetaOAuthCallback.tsx
// Landing del OAuth Meta. Meta redirige aquí con ?code&state tras consent.
// Posteamos al backend vía JWT → regresamos al panel de Empresa.

import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';

import { ApiError, exchangeMetaOAuth } from '@/lib/api_meta_oauth';

export function MetaOAuthCallback() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const [phase, setPhase] = useState<'running' | 'ok' | 'err'>('running');
  const [error, setError] = useState('');

  useEffect(() => {
    const code = search.get('code') || '';
    const state = search.get('state') || '';
    const fbError = search.get('error') || '';
    const fbErrorReason = search.get('error_reason') || '';

    if (fbError) {
      setPhase('err');
      setError(
        `Meta devolvió: ${fbError}${fbErrorReason ? ` (${fbErrorReason})` : ''}. ` +
        'Normalmente significa que el usuario canceló o la app no tiene permiso para este user.',
      );
      return;
    }
    if (!code || !state) {
      setPhase('err');
      setError('Faltan parámetros code o state en la URL.');
      return;
    }
    (async () => {
      try {
        await exchangeMetaOAuth(code, state);
        setPhase('ok');
        setTimeout(() => navigate('/m/travel-sales/company'), 1200);
      } catch (e: any) {
        setPhase('err');
        setError(e instanceof ApiError ? e.message : e?.message || 'Error');
      }
    })();
  }, [search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="bg-gray-800 border border-gray-700 rounded-xl p-8 max-w-md w-full text-center">
        <h2 className="text-xl font-semibold text-white mb-4">Meta — OAuth</h2>
        {phase === 'running' && (
          <div className="flex flex-col items-center gap-3 text-gray-300">
            <Loader2 className="animate-spin text-emerald-400" size={28} />
            Conectando tu cuenta…
          </div>
        )}
        {phase === 'ok' && (
          <div className="flex flex-col items-center gap-3 text-emerald-400">
            <CheckCircle size={32} />
            Conectado. Redirigiendo…
          </div>
        )}
        {phase === 'err' && (
          <div className="space-y-3">
            <div className="flex flex-col items-center gap-2 text-red-400">
              <XCircle size={28} />
              <div className="text-sm">{error}</div>
            </div>
            <Link
              to="/m/travel-sales/company"
              className="o-btn o-btn-ghost inline-flex items-center gap-2"
            >
              Volver a Empresa
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default MetaOAuthCallback;
